export default __webpack_public_path__ + "static/media/dra-michelle.cf76a32f.png";